export const isViewPageLite = () => window?.location?.search?.indexOf('lite=1') >= 0;
